import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import IconButton from "@mui/material/IconButton";

function Paginate({
    count,
    page,
    onPageChange,
}) {

    return (
        <div className="d-flex align-items-center">
            <span className="f-s-14">
                Occurrence {page} sur {count}
            </span>
            <div className="mb-1 ml-3">
                <IconButton
                    color="primary"
                    aria-label="previous occurrence"
                    component="label"
                    disabled={page <= 1}
                    onClick={() => onPageChange(page - 1)}
                >
                    <ExpandLessIcon />
                </IconButton>
                <IconButton
                    color="primary"
                    aria-label="next occurrence"
                    component="label"
                    disabled={page === count}
                    onClick={() => onPageChange(page + 1)}
                >
                    <ExpandMoreIcon />
                </IconButton>
            </div>
        </div>
    );
}

export default Paginate;